/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AvoEnv } from './Avo';

export const SegmentDestination = {
  make: function (env: AvoEnv) {
    /*
      Triggered during Avo initialization. Here you can initialize an analytics SDK with a development or production key
      based on the env parameter. If analytics SDK has already been initialized you can leave this function blank.
 
      Example: analytics.init(env);      
    */
  },
  logEvent: function (eventName: string, eventProperties: object) {
    // TODO: Replace the call below with a call to your destination
    window.analytics.track(eventName, eventProperties);
  },

  logPage: function (pageName: string, eventProperties: object) {
    // TODO: Replace the call below with a call to your destination
    window.analytics.page(pageName, eventProperties);
  },

  setUserProperties: function (userId: string, userProperties: object) {
    // TODO: Replace the call below with a call to your destination
    // analytics.people.set(userProperties);
  },

  identify: function (userId: string) {
    // TODO: Replace the call below with a call to your destination
    window.analytics.identify(userId);
  },

  unidentify: function () {
    // TODO: Replace the call below with a call to your destination
    window.analytics.reset();
  },

  revenue: function (amount: number, eventProperties: object) {
    // TODO: Replace the call below with a call to your destination
    // analytics.people.track_charge(amount, eventProperties);
  },

  page: function (pageName: string, eventProperties: object) {
    // TODO: Replace the call below with a call to your destination
    // Note: Mixpanel does not provide a native method for page or screen tracking, so we send an event instead. Other SDKs may have a dedicated page tracking method.
    window.analytics.track('Page Viewed', Object.assign(eventProperties, { pageName: pageName }));
  },

  // The following methods are used for group analytics and are not required
  setGroupProperties(groupType: string, groupId: string, groupProperties: object) {
    // TODO: Replace the call below with a call to your destination
    // analytics.get_group(groupType, groupId).set(groupProperties);
  },

  addCurrentUserToGroup: function (groupType: string, groupId: string, groupProperties: object) {
    // TODO: Replace the call below with a call to your destination
    // analytics.set_group(groupType, groupId);
    // analytics.get_group(groupType, groupId).set(groupProperties);
  },

  logEventWithGroups: function (eventName: string, eventProperties: string, groupTypesToGroupIds: object) {
    // TODO: Replace the call below with a call to your destination
    // analytics.track_with_groups(
    //   eventName,
    //   eventProperties,
    //   groupTypesToGroupIds,
    // );
  },
};
